import { Box, Grid2 as Grid, Typography } from '@mui/material';
import type { ContainerElement, Element } from '../../format/form-definition';
import { CanvasElement } from './CanvasElement';
import { useEmptyPlaceDrop } from '../drag-and-drop';
import { Droppable } from 'framework/dnd';
import { isContainer } from '../../format/elements';

interface CanvasElementsProps {
  elements: Element[];
  container: ContainerElement | null;
}

export const CanvasElements = ({ elements, container }: CanvasElementsProps) => {
  if (elements.length === 0) return <EmptyPlace container={container} />;
  return (
    <Grid container columns={6} spacing={1} alignItems="flex-start" sx={{ '.MuiFormControl-fullWidth': { mb: 0 } }}>
      {elements.map(element => (
        <CanvasElement key={element.id} element={element}>
          {isContainer(element) && <CanvasElements elements={element.elements} container={element} />}
        </CanvasElement>
      ))}
    </Grid>
  );
};

const EmptyPlace = ({ container }: { container: ContainerElement | null }) => {
  const drop = useEmptyPlaceDrop(container);
  const text =
    container === null
      ? 'Drag an element here from the right, or click one to add it.'
      : container.kind === 'section'
        ? 'Empty section. Drag an element here, or select the section and click one on the right.'
        : 'Empty group. Drag a field here, or select the group and click one on the right.';
  return (
    <Droppable params={drop.params}>
      {({ droppableRef }) => (
        <Box
          ref={droppableRef}
          sx={{
            p: 2.5,
            border: 1,
            borderStyle: 'dashed',
            borderColor: drop.over ? 'primary.main' : 'border.medium',
            borderRadius: 1,
            backgroundColor: drop.over ? 'action.hover' : 'transparent',
          }}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            {text}
          </Typography>
        </Box>
      )}
    </Droppable>
  );
};
